(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
	constructor() {
	super();
	}

	connectedCallback() {
		this.header = document.querySelector('.shopify-section-header');
		this.headerWrapper = document.querySelector('.header-wrapper');
		this.headerInner = document.querySelector('.header');
		this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
		this.headerBounds = {};
		this.currentScrollTop = 0;
		this.preventReveal = false;
		this.predictiveSearch = this.querySelector('predictive-search');

		this.onScrollHandler = this.onScroll.bind(this);
		this.hideHeaderOnScrollUp = () => this.preventReveal = true;

		this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.addEventListener('scroll', this.onScrollHandler, false);

		this.createObserver();
		
		if (this.headerIsAlwaysSticky) this.reveal; 
	}

	disconnectedCallback() {
		this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.removeEventListener('scroll', this.onScrollHandler);
	}

	createObserver() {
		let observer = new IntersectionObserver((entries, observer) => {
		this.headerBounds = entries[0].intersectionRect;
		observer.disconnect();
		});

		if (this.header) {
			observer.observe(this.header);
		}
	}

	onScroll() {
	const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

	if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 1) {
		this.header.classList.add('shopify-section-header-sticky','shopify-section-header-always-sticky');
	};

	if (this.headerIsAlwaysSticky && scrollTop < this.header.offsetHeight) {
		this.header.classList.remove('shopify-section-header-sticky');
	};

	if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		if (this.preventHide) return;
		requestAnimationFrame(this.hide.bind(this));
		} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		if (!this.preventReveal) {
		requestAnimationFrame(this.reveal.bind(this));
		} else {
			window.clearTimeout(this.isScrolling);

			this.isScrolling = setTimeout(() => {
			this.preventReveal = false;
			}, 66);

			requestAnimationFrame(this.hide.bind(this));
		}
		} else if (scrollTop <= this.headerBounds.top) {
		requestAnimationFrame(this.reset.bind(this));
		}

		this.currentScrollTop = scrollTop;
	}

	hide() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
		this.closeMenuDisclosure();
	}

	reveal() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.add('shopify-section-header-sticky', 'animate');
		this.header.classList.remove('shopify-section-header-hidden');
	}

	reset() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
	}

	closeMenuDisclosure() {
		this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
		if (this.disclosures) {
			this.disclosures.forEach(disclosure => {
				disclosure.close(); 
			});
		}
		this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
			if (this.disclosureLists) {
				this.disclosureLists.forEach(disclosureList => {
					disclosureList.setAttribute('hidden', true); 
				});
			}
		}
	}

	customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["qz-system"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('qz-system')) {
    customElements.define(
      'qz-system',
      class extends HTMLElement {
        connectedCallback() {
          this.tabs = [...this.querySelectorAll('[role="tab"]')];
          this.panels = [...this.querySelectorAll('.qz-system__panel')];
          this.stations = [...this.querySelectorAll('.qz-system__station')];
          this.rotor = this.querySelector('.qz-system__rotor');
          this.ink = this.querySelector('.qz-system__ink');
          this.angles = (this.dataset.angles || '-120,-30,60,150').split(',').map(Number);
          this.tabIndex = 0;
          this.rowIndex = 0;
          this.angle = this.angles[0];
          if (this.rotor) this.rotor.style.transform = `rotate(${this.angle}deg)`;
          this.classList.add('is-ready');

          this.tabs.forEach((tab, i) => {
            tab.addEventListener('click', () => this.selectTab(i));
            tab.addEventListener('keydown', (e) => {
              const last = this.tabs.length - 1;
              let next = null;
              if (e.key === 'ArrowRight') next = i === last ? 0 : i + 1;
              if (e.key === 'ArrowLeft') next = i === 0 ? last : i - 1;
              if (e.key === 'Home') next = 0;
              if (e.key === 'End') next = last;
              if (next === null) return;
              e.preventDefault();
              this.selectTab(next);
              this.tabs[next].focus();
            });
          });

          this.panels.forEach((panel) => {
            panel.querySelectorAll('.qz-system__row-btn').forEach((btn, i) => {
              btn.addEventListener('click', () => {
                const isOpen = btn.getAttribute('aria-expanded') === 'true';
                this.openRow(isOpen ? -1 : i);
              });
            });
          });

          const hover = window.matchMedia('(hover: hover) and (pointer: fine)');
          this.stations.forEach((station, i) => {
            station.addEventListener('click', () => this.openRow(i));
            station.addEventListener('mouseenter', () => { if (hover.matches) this.openRow(i); });
          });

          this.moveInk();
          window.addEventListener('resize', () => this.moveInk(), { passive: true });
          if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => this.moveInk());
        }

        selectTab(index) {
          this.tabIndex = index;
          this.tabs.forEach((tab, i) => {
            const on = i === index;
            tab.setAttribute('aria-selected', on);
            tab.tabIndex = on ? 0 : -1;
          });
          this.panels.forEach((panel, i) => { panel.hidden = i !== index; });
          this.moveInk();
          this.openRow(this.rowIndex < 0 ? 0 : this.rowIndex);
        }

        openRow(index) {
          const panel = this.panels[this.tabIndex];
          if (!panel) return;
          panel.querySelectorAll('.qz-system__row').forEach((row, i) => {
            const on = i === index;
            row.classList.toggle('is-open', on);
            const btn = row.querySelector('.qz-system__row-btn');
            if (btn) btn.setAttribute('aria-expanded', on);
          });
          this.rowIndex = index;
          if (index < 0) return;
          this.stations.forEach((s, i) => {
            s.classList.toggle('is-active', i === index);
            s.setAttribute('aria-pressed', i === index);
          });
          this.moveDot(index);
        }

        moveDot(index) {
          if (!this.rotor) return;
          const target = this.angles[index] || 0;
          /* shortest way round the ring */
          const delta = ((((target - this.angle) % 360) + 540) % 360) - 180;
          this.angle += delta;
          this.rotor.style.transform = `rotate(${this.angle}deg)`;
        }

        moveInk() {
          if (!this.ink) return;
          const tab = this.tabs[this.tabIndex];
          if (!tab) return;
          this.ink.style.width = tab.offsetWidth + 'px';
          this.ink.style.transform = `translateX(${tab.offsetLeft}px)`;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["qz-tour"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('qz-tour')) {
    customElements.define(
      'qz-tour',
      class extends HTMLElement {
        connectedCallback() {
          this.tabs = [...this.querySelectorAll('[role="tab"]')];
          this.panels = [...this.querySelectorAll('[role="tabpanel"]')];
          if (!this.tabs.length) return;
          this.querySelector('[role="tablist"]').hidden = false;
          this.tabs.forEach((tab, i) => {
            tab.addEventListener('click', () => {
              this.stopAuto();
              this.select(i);
            });
            tab.addEventListener('keydown', (e) => {
              if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
              this.stopAuto();
              const next = (i + (e.key === 'ArrowRight' ? 1 : -1) + this.tabs.length) % this.tabs.length;
              this.select(next);
              this.tabs[next].focus();
            });
          });
          this.select(0);
          this.setupAuto();
        }
        /* Auto-advance: only while in view, paused on hover, stops for good
           once the visitor picks a tab. Off for reduced motion and in the editor. */
        setupAuto() {
          const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          const editor = window.Shopify && window.Shopify.designMode;
          if (reduced || editor || this.tabs.length < 2) return;
          this.auto = true;
          this.ms = 6000;
          this.style.setProperty('--qz-tour-ms', this.ms + 'ms');
          this.addEventListener('mouseenter', () => this.clearTimer());
          this.addEventListener('mouseleave', () => this.schedule());
          this.addEventListener('focusin', () => this.stopAuto());
          new IntersectionObserver(([entry]) => {
            this.inView = entry.isIntersecting;
            if (this.inView) this.schedule();
            else this.clearTimer();
          }, { threshold: 0.35 }).observe(this);
        }
        schedule() {
          this.clearTimer();
          if (!this.auto || !this.inView) return;
          const tab = this.tabs[this.current];
          void tab.offsetWidth;
          tab.classList.add('is-timing');
          this.timer = setTimeout(() => {
            this.select((this.current + 1) % this.tabs.length);
            this.schedule();
          }, this.ms);
        }
        clearTimer() {
          clearTimeout(this.timer);
          this.tabs.forEach((t) => t.classList.remove('is-timing'));
        }
        stopAuto() {
          this.auto = false;
          this.clearTimer();
        }
        select(index) {
          this.current = index;
          this.tabs.forEach((tab, i) => {
            const on = i === index;
            tab.setAttribute('aria-selected', on);
            tab.tabIndex = on ? 0 : -1;
            this.panels[i].hidden = !on;
            if (on) this.panels[i].querySelectorAll('img[loading="lazy"]').forEach((img) => (img.loading = 'eager'));
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["qz-video"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('qz-video')) {
    customElements.define(
      'qz-video',
      class extends HTMLElement {
        connectedCallback() {
          if (this.button) return;
          const link = this.querySelector('[data-qz-video-trigger]');
          if (!link || !this.dataset.src) return;
          /* Upgrade the no-JS link into a real button. */
          const button = document.createElement('button');
          button.type = 'button';
          button.className = link.className;
          button.setAttribute('aria-label', link.getAttribute('aria-label'));
          button.append(...link.childNodes);
          link.replaceWith(button);
          this.button = button;
          this.label = button.getAttribute('aria-label');
          this.userPaused = false;
          this.autoPausing = false;
          button.addEventListener('click', () => this.onTrigger());
          if (this.canAutoplay()) this.setupAutoplay();
        }
        disconnectedCallback() {
          if (this.loadObserver) this.loadObserver.disconnect();
          if (this.viewObserver) this.viewObserver.disconnect();
        }
        canAutoplay() {
          if (this.dataset.playback === 'click') return false;
          if (!('IntersectionObserver' in window)) return false;
          if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return false;
          const c = navigator.connection;
          if (c && c.saveData) return false;
          return true;
        }
        /* Pick the source: mp4 <= 720p on small screens / slow networks, else best <= 1080p. */
        pickSource() {
          const c = navigator.connection;
          const slow = !!(c && /(^|-)(2g|3g)$/.test(c.effectiveType || ''));
          const small = window.innerWidth < 750 || slow;
          let list = [];
          try { list = JSON.parse(this.dataset.sources || '[]'); } catch (e) { list = []; }
          if (list.length) {
            const cap = small ? 720 : 1080;
            const known = list.filter((s) => s.h > 0);
            const fit = known.filter((s) => s.h <= cap).sort((a, b) => b.h - a.h);
            if (fit.length) return fit[0].u;
            const unknown = list.find((s) => !(s.h > 0));
            if (unknown) return unknown.u;
            return known.sort((a, b) => a.h - b.h)[0].u;
          }
          if (small && this.dataset.srcMobile) return this.dataset.srcMobile;
          return this.dataset.src;
        }
        ensureVideo(preload) {
          if (this.video) return this.video;
          const frame = this.querySelector('.qz-video__frame');
          const video = document.createElement('video');
          video.className = 'qz-video__el';
          video.controls = true;
          video.muted = true;
          video.defaultMuted = true;
          video.playsInline = true;
          video.loop = true;
          video.preload = preload || 'auto';
          video.setAttribute('muted', '');
          video.setAttribute('playsinline', '');
          video.setAttribute('loop', '');
          video.setAttribute('aria-label', this.label || 'Product video');
          const poster = this.querySelector('.qz-video__poster');
          if (poster) video.poster = poster.currentSrc || poster.src;
          const source = document.createElement('source');
          source.src = this.pickSource();
          source.type = 'video/mp4';
          video.appendChild(source);
          video.addEventListener('playing', () => this.reveal());
          video.addEventListener('pause', () => {
            if (this.autoPausing) this.autoPausing = false;
            else this.userPaused = true;
          });
          video.addEventListener('play', () => { this.userPaused = false; });
          frame.insertBefore(video, frame.firstChild);
          this.video = video;
          return video;
        }
        /* Poster stays on top until the first frame is playing, then fades out. */
        reveal() {
          if (this.classList.contains('is-playing')) return;
          const hadFocus = document.activeElement === this.button;
          this.classList.add('is-playing');
          this.button.setAttribute('tabindex', '-1');
          this.button.setAttribute('aria-hidden', 'true');
          if (hadFocus) this.video.focus({ preventScroll: true });
        }
        tryPlay() {
          const p = this.video.play();
          if (p && p.catch) {
            p.catch(() => {
              /* Autoplay refused (e.g. low-power mode): show the play button. */
              if (!this.classList.contains('is-playing')) this.classList.remove('qz-video--auto');
            });
          }
        }
        onTrigger() {
          this.ensureVideo('auto');
          this.userPaused = false;
          this.button.blur();
          this.tryPlay();
          this.video.focus({ preventScroll: true });
        }
        setupAutoplay() {
          this.classList.add('qz-video--auto');
          this.loadObserver = new IntersectionObserver(
            (entries) => {
              if (!entries.some((e) => e.isIntersecting)) return;
              this.loadObserver.disconnect();
              this.ensureVideo('auto').load();
            },
            { rootMargin: '300px 0px' }
          );
          this.loadObserver.observe(this);
          this.viewObserver = new IntersectionObserver(
            (entries) => {
              const ratio = entries[entries.length - 1].intersectionRatio;
              if (ratio >= 0.5) {
                if (this.userPaused) return;
                this.ensureVideo('auto');
                if (this.video.paused) this.tryPlay();
              } else if (ratio < 0.2 && this.video && !this.video.paused) {
                this.autoPausing = true;
                this.video.pause();
              }
            },
            { threshold: [0, 0.2, 0.5] }
          );
          this.viewObserver.observe(this.querySelector('.qz-video__frame'));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
